/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateAddressData } from './CreateAddressData';
import {
    CreateAddressDataFromJSON,
    CreateAddressDataFromJSONTyped,
    CreateAddressDataToJSON,
    CreateAddressDataToJSONTyped,
} from './CreateAddressData';
import type { RegisterCompanyDataThirdPartyReferralData } from './RegisterCompanyDataThirdPartyReferralData';
import {
    RegisterCompanyDataThirdPartyReferralDataFromJSON,
    RegisterCompanyDataThirdPartyReferralDataFromJSONTyped,
    RegisterCompanyDataThirdPartyReferralDataToJSON,
    RegisterCompanyDataThirdPartyReferralDataToJSONTyped,
} from './RegisterCompanyDataThirdPartyReferralData';

/**
 * 
 * @export
 * @interface RegisterCompanyData
 */
export interface RegisterCompanyData {
    /**
     * 
     * @type {string}
     * @memberof RegisterCompanyData
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterCompanyData
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterCompanyData
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterCompanyData
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterCompanyData
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterCompanyData
     */
    password: string;
    /**
     * 
     * @type {CreateAddressData}
     * @memberof RegisterCompanyData
     */
    address: CreateAddressData;
    /**
     * The locales a company can be set to, which drive both translations and the formatting of dates and numbers.
     * @type {string}
     * @memberof RegisterCompanyData
     */
    locale?: RegisterCompanyDataLocaleEnum;
    /**
     * 
     * @type {string}
     * @memberof RegisterCompanyData
     */
    timezone: string;
    /**
     * 
     * @type {number}
     * @memberof RegisterCompanyData
     */
    billingPackageId: number;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterCompanyData
     */
    terms: boolean;
    /**
     * 
     * @type {string}
     * @memberof RegisterCompanyData
     */
    recaptchaToken: string;
    /**
     * A referral code from an existing company on Shiftie.
     * @type {string}
     * @memberof RegisterCompanyData
     */
    firstPartyReferralCode?: string;
    /**
     * 
     * @type {RegisterCompanyDataThirdPartyReferralData}
     * @memberof RegisterCompanyData
     */
    thirdPartyReferralData?: RegisterCompanyDataThirdPartyReferralData;
}

/**
* @export
* @enum {string}
*/
export enum RegisterCompanyDataLocaleEnum {
    EnGb = 'en-GB',
    EnUs = 'en-US',
    FrFr = 'fr-FR'
}


/**
 * Check if a given object implements the RegisterCompanyData interface.
 */
export function instanceOfRegisterCompanyData(value: object): value is RegisterCompanyData {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('timezone' in value) || value['timezone'] === undefined) return false;
    if (!('billingPackageId' in value) || value['billingPackageId'] === undefined) return false;
    if (!('terms' in value) || value['terms'] === undefined) return false;
    if (!('recaptchaToken' in value) || value['recaptchaToken'] === undefined) return false;
    return true;
}

export function RegisterCompanyDataFromJSON(json: any): RegisterCompanyData {
    return RegisterCompanyDataFromJSONTyped(json, false);
}

export function RegisterCompanyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterCompanyData {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'companyName': json['companyName'],
        'password': json['password'],
        'address': CreateAddressDataFromJSON(json['address']),
        'locale': json['locale'] == null ? undefined : json['locale'],
        'timezone': json['timezone'],
        'billingPackageId': json['billingPackageId'],
        'terms': json['terms'],
        'recaptchaToken': json['recaptchaToken'],
        'firstPartyReferralCode': json['firstPartyReferralCode'] == null ? undefined : json['firstPartyReferralCode'],
        'thirdPartyReferralData': json['thirdPartyReferralData'] == null ? undefined : RegisterCompanyDataThirdPartyReferralDataFromJSON(json['thirdPartyReferralData']),
    };
}

  export function RegisterCompanyDataToJSON(json: any): RegisterCompanyData {
      return RegisterCompanyDataToJSONTyped(json, false);
  }

  export function RegisterCompanyDataToJSONTyped(value?: RegisterCompanyData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'companyName': value['companyName'],
        'password': value['password'],
        'address': CreateAddressDataToJSON(value['address']),
        'locale': value['locale'],
        'timezone': value['timezone'],
        'billingPackageId': value['billingPackageId'],
        'terms': value['terms'],
        'recaptchaToken': value['recaptchaToken'],
        'firstPartyReferralCode': value['firstPartyReferralCode'],
        'thirdPartyReferralData': RegisterCompanyDataThirdPartyReferralDataToJSON(value['thirdPartyReferralData']),
    };
}

